var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"subscribe-reply"},[_c('div',{staticClass:"title"},[_vm._v(" 自动回复以下消息的其中一条 ")]),(!_vm.loading)?_c('wx-auto-reply-editor',{attrs:{"current-id":this.reply.wxAutoReply.id,"hidden-keyword":true,"hidden-title":true,"hidden-reply-method":true,"no-border":true,"hidden-content-label":true}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }